import { Drawer as MuiDrawer, DrawerProps } from '@material-ui/core';

const Drawer = ({ open, onClose, children, ...props }: DrawerProps) => {
  return (
    <MuiDrawer open={open} onClose={onClose} {...props}>
      {children}
    </MuiDrawer>
  );
};

export default Drawer;
